import React from 'react';
import styled, { css } from 'styled-components';
import { domain } from '../../../lib/env';
import { FontAwesomeIcon as FAIcon } from '@fortawesome/react-fontawesome';
import {
  faPaperPlane, faCog, faCheck, faTimes,
} from '@fortawesome/free-solid-svg-icons';
import Spinner from '../../Spinner/Spinner';

const Container = styled.div`
  display: grid;
  box-shadow: var(--elevation-1);
  grid-row-gap: 1rem;
  position: absolute;
  bottom: 0;
  padding: 2rem 1rem;
  width: 100%;
  z-index: 7;
  background-color: #efefef;

  p {
    font-size: 1rem;
  }

  div {
    display: grid;
    grid-template-columns: min-content min-content;
    grid-gap: 1rem;
  }
`;

const RedirectLink = styled.a`
  text-decoration: none;
  color: var(--color-primary);
`;

export  const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 10.62rem;
  padding: 0.75rem 0.5rem;
  background-color: var(--color-primary);
  color: var(--font-color-secondary);
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.85rem;

  ${props => props.invert
    && css`
      background-color: var(--color-secondary);
      color: var(--color-primary);
      border: 1px solid var(--color-primary);

      svg {
        color: var(--color-primary);
      }
    `}

  svg {
    margin-right: 0.5rem;
  }

  &:hover {
    filter: brightness(0.96);

    ${RedirectLink} {
      text-decoration: underline;
    }
  }
`;

const Helper = ({ id, sendEmail, emailState }) => {
  const { sending, error, sent } = emailState;

  const LoadingButton = () => {
    if (sending) {
      return (
        <Button type="button">
          <Spinner white />
        </Button>
      );
    }

    if (error) {
      return (
        <Button type="button" onClick={() => sendEmail(id)}>
          <FAIcon icon={faTimes} css="color: red;" />
        </Button>
      );
    }

    if (sent) {
      return (
        <Button type="button">
          <FAIcon icon={faCheck} />
        </Button>
      );
    }

    return (
      <Button type="button" onClick={() => sendEmail(id)}>
        <FAIcon icon={faPaperPlane} />
        E-Mail erneut senden
      </Button>
    );
  };

  return (
    <Container>
      <div>
        <LoadingButton />
        <Button type="button" invert>
          <FAIcon icon={faCog} />
          <RedirectLink
            href={`${domain}/admin/users/${id}/edit`}
            rel="noopener noreferrer"
            target="_blank"
          >
            Password setzen
          </RedirectLink>
        </Button>
      </div>
    </Container>
  );
};

export default Helper;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Helper/Helper.jsx